// Validação do fluxo do canvas — função pura, sem i18n (retorna chaves +
// params pro componente traduzir). Cada issue: { level: 'error'|'warn', key, params }.
// Não bloqueia salvar; só avisa o que pode deixar o agente quebrado/incompleto.
// Nós que fazem parte do CAMINHO do fluxo (precisam estar conectados). Tools
// (tool_*), notas e prospecção são standalone por natureza — não viram "órfãos".
const FLOW_KINDS = [
  'agent',
  'classify',
  'guardrails',
  'approve',
  'http_request',
  'if_else',
  'send',
  'end',
];

export function validateFlow(nodes = [], edges = []) {
  const issues = [];
  const touched = new Set();
  edges.forEach(e => {
    touched.add(e.source);
    touched.add(e.target);
  });

  const isBlank = v => !String(v ?? '').trim();

  const agents = nodes.filter(n => n.data?.kind === 'agent');
  if (agents.length === 0) {
    issues.push({ level: 'error', key: 'NO_AGENT' });
  } else if (isBlank(agents[0].data?.instruction)) {
    issues.push({ level: 'warn', key: 'AGENT_NO_PROMPT' });
  }

  nodes.forEach(n => {
    const d = n.data || {};
    const label = d.label || d.kind;

    if (d.kind === 'start') {
      if (!touched.has(n.id))
        issues.push({ level: 'warn', key: 'START_DISCONNECTED' });
      return;
    }
    if (FLOW_KINDS.includes(d.kind) && !touched.has(n.id)) {
      issues.push({ level: 'warn', key: 'ORPHAN', params: { label } });
    }
    if (d.kind === 'http_request' && isBlank(d.endpoint)) {
      issues.push({
        level: 'error',
        key: 'HTTP_NO_ENDPOINT',
        params: { label },
      });
    }
    if (d.kind === 'classify') {
      const cats = (d.categories || []).filter(c => c && c.name);
      if (cats.length < 2)
        issues.push({ level: 'warn', key: 'CLASSIFY_FEW', params: { label } });
    }
    if (d.kind === 'approve' && isBlank(d.approvalPrompt)) {
      issues.push({
        level: 'warn',
        key: 'APPROVE_NO_PROMPT',
        params: { label },
      });
    }
    if (
      d.kind === 'if_else' &&
      isBlank(d.condition) &&
      !(d.conditionRules || []).length
    ) {
      issues.push({ level: 'warn', key: 'IFELSE_NO_COND', params: { label } });
    }
    // Nenhuma checagem de "caixa obrigatória" para flexcalls_call: o modo
    // "both" (ligar e receber) é Fase 2 e fica desabilitado no inspector —
    // bloquear o save por falta de caixa aqui puniria uma configuração que o
    // operador nem consegue mais escolher, sem um jeito de resolver.
  });

  return issues;
}
